import { Formula } from '../../lib/types/models/formula/formula'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export const getFormula = (id: number) => {
  return restApiClient.url(constructApiUrl(API.formulas.get.url, { id })).get<Formula>()
}
